<!--  -->
<template>
  <div>
    <div class="band_box">
      <div>
        <div class="serch_box">
          <!-- <el-input v-model="obr.marketing_asset_id" placeholder="请输入自有员工编号" style="width:200px" />
          <el-input v-model="obr.marketing_asset_name" placeholder="请输入员工姓名" style="width:200px;margin-left:10px" /> -->
          <el-input
            v-model="obr.marketing_asset_id"
            clearable
            style="width:270px;margin-right:10px"
            placeholder="推广内容资产id，可以用逗号连接"
          />
          <el-input
            v-model="obr.marketing_asset_name"
            clearable
            style="width:270px;margin-right:10px"
            placeholder="推广内容资产名称"
          />
          <el-button
            type="primary"
            class="search_icon"
            icon="el-icon-search"
            @click="secahclkick"
          />
          <el-tag v-if="arrs.length!=0" type="success" style="margin-top:5px;margin-left:10px">已选：{{ arrs.length }}个</el-tag>
        </div>
        <div class="choses_box">
          <div
            class="select_box"
            :class="[fullName?'choose_blockr':'']"
            @click="whole"
          />
          <div
            v-if="fullName"
            @click="whole"
          >
            取消全选
          </div>
          <div
            v-else
            @click="whole"
          >
            全选
          </div>
        </div>
        <!-- <div class="choose_allblock">
          <div
            v-for="item,index in arr"
            :key="index"
            :class="[item.tips?'have ':'']"
            class="choose_block"
          >
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips?'choose_blockr':'']"
              @click="itenclick(item,index)"
              style="cursor: pointer;"
            />
            <img
              style="width:50px"
              :src="item.cover_url"
              alt=""
              srcset=""
            >
            <div style="margin-left:10px">
              <div>
                {{ item.marketing_asset_name }}
              </div>
              <div>
                <div style="margin:5px 0px">ID:{{item.marketing_asset_id}}</div>
                <div>{{item.mall}}</div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="choose_allblock">
          <div
            v-for="(item, index) in arr"
            :key="index"
            :class="[item.tips ? 'have' : '']"
            class="choose_block"
          >
            <div
              v-if="item.can_checked === 9"
              class="select_boxone"
            />
            <div
              v-else
              class="select_box"
              :class="[item.tips ? 'choose_blockr' : '']"
              style="cursor: pointer;"
              @click="itenclick(item, index)"
            />
            <img
              style="width: 50px"
              :src="item.cover_url"
              alt=""
            >
            <div style="margin-left: 10px">
              <div>{{ item.marketing_asset_name }}</div>
              <div style="margin: 5px 0px">ID: {{ item.marketing_asset_id }}</div>
              <div style="color:#46acff">{{ item.mall }}</div>
            </div>
          </div>
        </div>

      </div>
      <!-- <div class="rigboxr">
        <div class="choiceofficialaccount">选中的投放推广内容资产</div>
        <el-tag
          v-for="itemr,index in arrs"
          :key="index"
          style="margin-right:10px;margin-bottom:5px"
          closable
          :type="itemr.type"
          @close="rightclick(itemr.marketing_asset_id,index)"
        >
          {{ itemr.marketing_asset_name }}
        </el-tag>
      </div> -->
    </div>
    <pagination-right
      style="padding:0px"
      :total="total"
      :current-page="obr.page"
      :page-size="30"
      :page-sizes="[10,20,30]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div class="que_box">
      <el-button
        type="primary"
        @click="quebtn"
      >确定</el-button>
    </div>

  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { marketingtargetassets } from '@/api/customer'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      searchvalue: null,
      searchTopicLoading: false, // 搜索锁
      topicList: [], // 公众号临时绑定数组
      options: [], // 公众号列表数组
      value1: [], // 公众号多选完成集合数组
      id: null, // 点击保存的id
      tableData: [], // 表格数组
      arr: [],
      arrs: [],
      arrsw: [],

      obr: {
        account_id: null,
        marketing_target_type: null,
        page: 1,
        page_size: 30,
        marketing_asset_id: null,
        marketing_asset_name: null
      },
      total: null,
      sp_strategy_no: null
    }
  },
  computed: {
    fullName: function() {
      return this.arr
        .filter(num => {
          return num.can_checked !== 9
        })
        .every(function(item) {
          return item.tips === true
        })
    }
  },
  created() {},
  mounted() {},
  methods: {
    secahclkick() {
      this.obr.page = 1
      this.list()
    },

    // 点击确定
    async quebtn() {
      console.log('arrs', this.arrs)
      this.arrsw = []
      this.arrsw = this.arrs.map(item => {
        // item是数组中的每一个值
        return item.marketing_asset_id
      })
      if (this.arrs.length === 0) {
        this.$message.error('请选择要绑定的员工')
        return
      }
      this.$emit('bandarr', this.arrs)
      console.log('this.arrs', this.arrs)
    },

    itenclick(item, index) {
      item.tips = !item.tips
      if (item.tips) {
        this.arrs.push({ marketing_asset_id: item.marketing_asset_id, marketing_asset_name: item.marketing_asset_name })
      } else {
        const index = this.arrs.findIndex(items => {
          return items.marketing_asset_id === item.marketing_asset_id
        })
        this.arrs.splice(index, 1)
      }
    },
    whole() {
      if (this.fullName === true) {
        // if (this.arrs.length === this.arr.length) {
        console.log('666')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = false
            const index = this.arrs.findIndex(items => {
              return items.marketing_asset_id === item.marketing_asset_id
            })
            this.arrs.splice(index, 1)
          }
        })
      } else {
        console.log('777')
        this.arr.forEach(item => {
          if (item.can_checked === 1) {
            item.tips = true
            this.arrs.map(re => re.marketing_asset_id).includes(item.marketing_asset_id) || this.arrs.push({ marketing_asset_id: item.marketing_asset_id, marketing_asset_name: item.marketing_asset_name })
          }
        })
        // this.arr.forEach((item) => {
        //   this.arrs.includes(item.id) || this.arr.push(item.id)
        // })
      }
    },
    rightclick(marketing_asset_id, index) {
      console.log(marketing_asset_id, index)
      this.arrs.splice(index, 1)
      this.arr.findIndex(items => {
        if (items.marketing_asset_id === marketing_asset_id) {
          items.tips = false
        }
      })
    },
    sendr(arr, newaccount_id, marketing_target_type) {
      console.log('里面', newaccount_id, marketing_target_type)
      this.obr.account_id = newaccount_id
      this.obr.marketing_target_type = marketing_target_type
      // eslint-disable-next-line eqeqeq
      if (arr != undefined) {
        this.arrs = arr
      }
      this.list()
    },
    async list() {
      const data = await marketingtargetassets(this.obr)
      this.total = data.data.total
      data.data.list.forEach(item => {
        item.tips = false
        item.can_checked = 1
      })
      this.arr = data.data.list
      this.arr.forEach(item => {
        // console.log('item', item)
        this.arrs.forEach(items => {
          if (items.marketing_asset_id === item.marketing_asset_id) {
            console.log('items', item)
            item.tips = true
          }
        })
      })
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      console.log('111')
      this.obr.pageSize = e
      this.obr.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obr.page = e
      this.list()
    },
    set(id) {
      this.arrs.forEach(item => {
        if (item.marketing_asset_id === id) {
          item.tips = false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.allbox {
  padding: 30px;
}
.que_box {
  margin-top: 20px;
}
.have {
  color: #409eff;
}
.serch_box {
  display: flex;
  margin-bottom: 10px;
}
.search_icon {
  margin-left: 10px;
}
.band_box {
  display: flex;
}
.choses_box {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}
.select_box {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid skyblue;
  margin-right: 7px;
}
.select_boxone {
  height: 14px;
  width: 14px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-right: 7px;
  background-color: #ccc;
}
/* .choose_block {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  margin-right: 10px;
} */
.choose_blockr {
  background: #409eff;
}
.rigboxr {
  margin-left: 85px;
  border-left: 1px solid #ccc;
  padding-left: 30px;
  max-height: 520px;
  overflow: hidden;
  overflow-y: scroll;
}
:-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.choiceofficialaccount {
  margin-bottom: 10px;
}
.select_spacing {
  margin-bottom: 5px;
}
/* .choose_allblock {
  height: 370px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
} */

.choose_allblock {
  column-count: 2;
  column-gap: 20px;
  max-height: calc(15 * 55px); /* 每个块大约60px高度，控制最大高度 */
}

.choose_block {
  break-inside: avoid;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
